import "./style.scss";
import LogoTiva from "../../assets/logo-tiva-red.svg";
import FaceSadIcon from "../../assets/face-sad.icon.svg";

export const ErrorTemplate = ({ title, description }: { title: string; description: string }) => {
    return (
        <div className="error-template">
            <a href="/login" className="error-template-link">
                <img src={LogoTiva} alt="" />
            </a>
            <div className="error-template-content">
                <div className="error-template-content-title">
                    <img className="error-template-content-title__icon" src={FaceSadIcon} alt="" />
                    <span className="error-template-content-title__text">{title}</span>
                </div>
                <div className="error-template-content-description">
                    <span className="error-template-content-description__text">{description}</span>
                </div>
            </div>
        </div>
    );
};
